import React, { useState } from "react";

const CustomAccordion = ({
  title,
  children,
  isOpen,
  toggleAccordion,
  subtitle,
}) => {
  const svgStyle = {
    transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)",
    transition: "transform 0.3s ease",
  };

  return (
    <div className="accordion-custom">
      <div className="accordion-header" onClick={toggleAccordion}>
        <h2>{title}</h2>
      </div>
      <div className={`accordion-content ${isOpen ? "open" : ""}`}>
        {subtitle && <p className="accordion-subtitle">{subtitle}</p>}
        {children}
      </div>
      <div className="line" onClick={toggleAccordion}>
        <svg
          width="50"
          height="50"
          viewBox="0 0 82 82"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <circle
            cx="41"
            cy="41"
            r="39.5"
            fill="white"
            stroke="#DFEBF6"
            strokeWidth="3"
          />
          <path
            d="M23 30L41.5 57L60 30"
            stroke="#DFEBF6"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default CustomAccordion;
